export class TradingAccountModel {

    public id: string;
    public tradesCount: number;
    public result: number;
    public inOut: number;
    public firstDeposit: number;
    public equity: number;
    public currency: string;
    public balance: number;
    public login: string;
    public group: string;
    public type: string;
    public platform: string;
    public forexTurnover: number;
    public commoditiesTurnover: number;
    public indicesTurnover: number;
    public cpProviderId: number;
    public cpSubscriberId: number;

    constructor(obj?: any) {
        this.id                     = obj && obj.id                     || '';
        this.tradesCount            = obj && obj.tradesCount            || null;
        this.result                 = obj && obj.result                 || null;
        this.inOut                  = obj && obj.inOut                  || null;
        this.firstDeposit           = obj && obj.firstDeposit           || null;
        this.equity                 = obj && obj.equity                 || null;
        this.currency               = obj && obj.currency               || '';
        this.balance                = obj && obj.balance                || null;
        this.login                  = obj && obj.login                  || '';
        this.group                  = obj && obj.group                  || '';
        this.type                   = obj && obj.type                   || '';
        this.platform               = obj && obj.platform               || '';
        this.forexTurnover          = obj && obj.forexTurnover          || null;
        this.commoditiesTurnover    = obj && obj.commoditiesTurnover    || null;
        this.indicesTurnover        = obj && obj.indicesTurnover        || null;
        this.cpProviderId           = obj && obj.cpProviderId           || null;
        this.cpSubscriberId         = obj && obj.cpSubscriberId         || null;

    }
}



// WEBPACK FOOTER //
// ./src/app/models/trading-account.model.ts